<div [ngClass]="{ 'half-screen': selected }" class="main-container">
  <div class="table-container">
    <app-list-header
      [title]="title"
      [searchPlaceholder]="'branches.search' | translate"
      [searchTerm]="searchTerm | async"
      (searchTermChange)=" searchTerm.next($event);searchBranches()"
      (clearSearch)="clearBranchFilter()"
      (addNewItem)="createNewBranch()"
    >
    </app-list-header>

    <table class="table">
      <thead>
        <tr>
          <th class="name-header"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let branch of filteredBranch | async"
          (click)="select(branch)"
          [class.selected]="branch === selected"
        >
          <td>{{ branch.name }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
